<template>
    <gz-auth-view-template :bc="false">
        <GZ-StaticNotification slot="notification"/>
        <!-- <GZ-PageTitle title="Сотрудники" slot="title"/>         -->
        
        <section slot="above-content" class="gz-tabs gz-tabs__section">
            <router-link 
                to="/admin/staff/staff-list" 
                class="gz-tabs__item"
            >Список сотрудников</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>        
    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'AdminStaffView'
}
</script>